import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import React, { ReactElement, FunctionComponent } from 'react'
import Image from '../../../BaseComponents/Image'
import BasicText from '../../../Theme/Fonts/BasicText'
import { getColorsByType } from '../Tab'
import { getBackgroundColorBorder } from '../Tab'
import { backgroundToFontColorMap } from '../../../utils/Colors'
import { TestID } from '../../../utils/PropTypesDefinitions'
import LinkProps from '../../../Link/LinkProps'
import NonFlexingContainer from '../../../Layouts/NonFlexingContainer'

export type StaticTabProps = {
    /** Text of the tab */
    title: string
    /** Sets the background color */
    backgroundColor?: 'onyx' | 'pearl'
    /** Determines if the tab occupies the whole space available */
    expand?: boolean
    /** Redirects user to the value assigned */
    href?: string
    /** Sets an icon for the tab with the correspondent url */
    imageUrl?: string
    /** info about imageUrl for seo */
    alt?: string
    /** displays the highlighted version of type = onyx with different border color*/
    isHighlight?: boolean
    /** the callback when the user presses on the forward icon
     *
     * @TJS-type function
     * */
    onPress?: () => void
} & LinkProps &
    TestID

const StaticTab: FunctionComponent<StaticTabProps> = ({
    title,
    backgroundColor = 'onyx',
    expand,
    href,
    imageUrl,
    alt,
    onPress,
    testID,
    webRel,
    isHighlight,
}): ReactElement => {
    const getImageContent = () => {
        if (!imageUrl) {
            return null
        }

        const image = (
            <Image
                imageUrl={imageUrl}
                alt={alt}
                width={18}
                aspectRatio="ORIGINAL"
                resizeMode="contain"
                size="S"
            />
        )

        if (backgroundColor !== 'onyx') {
            return (
                <Grid noExpand marginRight={4}>
                    {image}
                </Grid>
            )
        }

        return (
            <Grid noExpand marginRight={4}>
                <NonFlexingContainer
                    borderRadius={2}
                    backgroundColor="moon-3"
                    paddingY={1}
                    paddingX={1}
                    centerHorizontal
                    centerVertical
                >
                    {image}
                </NonFlexingContainer>
            </Grid>
        )
    }

    return (
        <Grid noExpand horizontal={!expand} testID={testID}>
            <Touchable onPress={onPress} href={href} webRel={webRel}>
                <Grid
                    height={isHighlight ? 43 : 44}
                    paddingX={5}
                    centerVertical
                    noExpand
                    horizontal={!expand}
                    backgroundColor={
                        getColorsByType(
                            backgroundColor,
                            backgroundToFontColorMap,
                            false,
                            isHighlight
                        ).backgroundColor
                    }
                >
                    {getImageContent()}
                    <BasicText
                        fontSize="FS14"
                        lineHeight="LH16"
                        color={
                            getColorsByType(
                                backgroundColor,
                                backgroundToFontColorMap,
                                false,
                                isHighlight
                            ).color
                        }
                        textAlign="center"
                        bold
                        uppercase
                        numberOfLines={1}
                    >
                        {title}
                    </BasicText>
                </Grid>
                {isHighlight ? (
                    <Grid
                        height={1}
                        backgroundColor={
                            getBackgroundColorBorder(true, backgroundColor, isHighlight, false)
                                .backgroundColor
                        }
                        noExpand
                    />
                ) : null}
            </Touchable>
        </Grid>
    )
}

export default StaticTab
